import { defineMessages } from "react-intl";
const messages = defineMessages({
    reportSettings: {
        id: "aiDiscoverability.pageTopHeader.reportSettings",
        defaultMessage: "Report Settings",
    },
});
export default messages;
